import { render, staticRenderFns } from "./roomPlan.vue?vue&type=template&id=2a7d1250&scoped=true"
import script from "./roomPlan.vue?vue&type=script&lang=js"
export * from "./roomPlan.vue?vue&type=script&lang=js"
import style0 from "./roomPlan.vue?vue&type=style&index=0&id=2a7d1250&lang=sass&scoped=true"
import style1 from "./roomPlan.vue?vue&type=style&index=1&id=2a7d1250&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d1250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7d1250')) {
      api.createRecord('2a7d1250', component.options)
    } else {
      api.reload('2a7d1250', component.options)
    }
    module.hot.accept("./roomPlan.vue?vue&type=template&id=2a7d1250&scoped=true", function () {
      api.rerender('2a7d1250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Hotel/components/roomPlan.vue"
export default component.exports